import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

import { type IconProps } from './Icon.types';
import { icons } from './icons';

export function Icon({ icon, className }: PropsWithClassName<IconProps>) {
  return <i className={cn(icons[icon], className)} />;
}
